import { withFormlyFormField, FormlyMatFormFieldModule } from '@ngx-formly/material/form-field';
export { FieldType } from '@ngx-formly/material/form-field';
import { withFormlyFieldInput, FormlyMatInputModule } from '@ngx-formly/material/input';
import { withFormlyFieldTextArea, FormlyMatTextAreaModule } from '@ngx-formly/material/textarea';
import { withFormlyFieldRadio, FormlyMatRadioModule } from '@ngx-formly/material/radio';
import { withFormlyFieldCheckbox, FormlyMatCheckboxModule } from '@ngx-formly/material/checkbox';
import { withFormlyFieldMultiCheckbox, FormlyMatMultiCheckboxModule } from '@ngx-formly/material/multicheckbox';
import { withFormlyFieldSelect, FormlyMatSelectModule } from '@ngx-formly/material/select';
import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';

function withFormlyMaterial() {
    return [
        withFormlyFormField(),
        withFormlyFieldInput(),
        withFormlyFieldTextArea(),
        withFormlyFieldRadio(),
        withFormlyFieldCheckbox(),
        withFormlyFieldMultiCheckbox(),
        withFormlyFieldSelect(),
    ];
}

class FormlyMaterialModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FormlyMaterialModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: FormlyMaterialModule, imports: [FormlyMatFormFieldModule,
            FormlyMatInputModule,
            FormlyMatTextAreaModule,
            FormlyMatRadioModule,
            FormlyMatCheckboxModule,
            FormlyMatMultiCheckboxModule,
            FormlyMatSelectModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FormlyMaterialModule, imports: [FormlyMatFormFieldModule,
            FormlyMatInputModule,
            FormlyMatTextAreaModule,
            FormlyMatRadioModule,
            FormlyMatCheckboxModule,
            FormlyMatMultiCheckboxModule,
            FormlyMatSelectModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FormlyMaterialModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormlyMatFormFieldModule,
                        FormlyMatInputModule,
                        FormlyMatTextAreaModule,
                        FormlyMatRadioModule,
                        FormlyMatCheckboxModule,
                        FormlyMatMultiCheckboxModule,
                        FormlyMatSelectModule,
                    ],
                }]
        }] });

/*
 * Public API Surface of material
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FormlyMaterialModule, withFormlyMaterial };
